import React from "react";
import styles from "./LoadingComponent.module.scss";
import { BeatLoader } from "react-spinners";

export const LoadingComponent = () => {
  return (
    <div className={styles.loaderContainer}>
      <div>Загрузка данных</div>
      <BeatLoader color="#3e8fcb" size={12} />
    </div>
  );
};
